import { AboutMeTypes } from '../../StepThreeTypes';

export type VoiceToTextBlockedError = {
  message: string;
  href: string;
};

const UNDERSTAND_STATEMENT_ERROR =
  'The person you are supporting needs to understand the statement above.';

const VOICE_TRANSCRIBING_CONSENT_ERROR =
  'The person you are supporting has not provided consent to use voice transcribing.';

const isYes = (value?: string) => value?.toLowerCase() === 'yes';

const getVoiceToTextBlockedErrors = (
  aboutMe: AboutMeTypes
): VoiceToTextBlockedError[] => {
  const errors: VoiceToTextBlockedError[] = [];

  if (!isYes(aboutMe.voiceTranscribingConsent?.understandsStatement)) {
    errors.push({
      message: UNDERSTAND_STATEMENT_ERROR,
      href: '#understands-statement-yes',
    });
  }

  if (!isYes(aboutMe.voiceTranscribingConsent?.happyForTranscribingService)) {
    errors.push({
      message: VOICE_TRANSCRIBING_CONSENT_ERROR,
      href: '#voice-transcribing-service-yes',
    });
  }

  return errors;
};

export default getVoiceToTextBlockedErrors;
